/// <amd-module name="Artifacts/Nuget/NuGetConstants" />

export class NuGetCiConstants {
  public static LicenseLinkClicked = "NuGetLicenseLinkClicked";
  public static ProjectLinkClicked = "NuGetProjectLinkClicked";
}
